import { render, staticRenderFns } from "./OrderFromCatalog.vue?vue&type=template&id=428e7c6f&scoped=true&"
import script from "./OrderFromCatalog.vue?vue&type=script&lang=js&"
export * from "./OrderFromCatalog.vue?vue&type=script&lang=js&"
import style0 from "./OrderFromCatalog.vue?vue&type=style&index=0&id=428e7c6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428e7c6f",
  null
  
)

export default component.exports